declare global {
  interface Window {
    _env_: {
      API_HOST: string;
      JUSTIN_URL: string;
      CLIENT_ID: string;
      SECRET_ID: string;
      GOOGLE_ANALYTICS_ID: string;
      GOOGLE_GTM_ID: string;
    };
  }
}

export const APP_CONFIG = {
  API_HOST: window._env_.API_HOST,
  JUSTIN_URL: window._env_.JUSTIN_URL,
  CLIENT_ID: window._env_.CLIENT_ID,
  SECRET_ID: window._env_.SECRET_ID,
  GOOGLE_ANALYTICS_ID: window._env_.GOOGLE_ANALYTICS_ID,
  GOOGLE_GTM_ID: window._env_.GOOGLE_GTM_ID,
};
